export default __webpack_public_path__ + "static/media/gov_bids_adrian_zenz.15fe225a.png";